import { useMediaQuery, useTheme } from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { OrganizationUserContext } from "contexts/Organization";
import {
  QuickSendDrawerContext,
  QuickSendTabView,
} from "contexts/QuickSendDrawer";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { isOnPage, routes } from "schemas/routes";

import { eligibleForProDiscount } from "features/Home/Banner/helpers";

export const usePageSize = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription, bannerDismissed } = useContext(SubscriptionContext);
  const { hasPastDue, plans, bannerPromoCodes } =
    useContext(SubscriptionContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isRecommendedPage = isOnPage(routes.recommendations);
  const isLargeRecommendedPage = isRecommendedPage && !isMobileScreen;
  const isOnboardingPage = isOnPage(routes.onboardingInfluencer);

  const isTwoColumnView =
    useMediaQuery("(max-width:800px)") && isLargeRecommendedPage;

  const { discoverTab, tabWidth } = useContext(DiscoverViewContext);
  const { brandView, setBrandView } = useContext(QuickSendDrawerContext);

  const hideBrandInfoViewDiscoverTab = () => {
    if (
      discoverTab &&
      isLargeRecommendedPage &&
      brandView !== QuickSendTabView.COLLAPSE
    ) {
      setBrandView(QuickSendTabView.COLLAPSE);
    } else if (!discoverTab && isLargeRecommendedPage) {
      setBrandView(QuickSendTabView.EXPAND);
    }
  };

  const hideBrandInfoTwoColumnView = () => {
    if (!isTwoColumnView) {
      return;
    }
  };

  const navigationWidth = isMobileScreen
    ? "100%"
    : discoverTab !== null
      ? `calc(100% - ${58 + tabWidth}px)`
      : "calc(100% - 58px)";
  const smallDiscoverScreen = useMediaQuery(
    discoverTab !== null ? "(max-width:1700px)" : "(max-width:1300px)",
  );
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const breaksDiscoverScreen =
    smallDiscoverScreen || (isLargeScreen && discoverTab !== null);

  const hasBanner =
    (hasPastDue ||
      eligibleForProDiscount(currentOrg, plans, subscription) ||
      Boolean(bannerPromoCodes && bannerPromoCodes?.length > 0)) &&
    !currentOrg?.isBrand &&
    !bannerDismissed;

  return {
    isTwoColumnView,
    hideBrandInfoViewDiscoverTab,
    hideBrandInfoTwoColumnView,
    isLargeRecommendedPage,
    isOnboardingPage,
    isRecommendedPage,
    navigationWidth,
    breaksDiscoverScreen,
    hasBanner,
  };
};
